import React, { useEffect, useState } from 'react'
import ProfileCard from '../CardComponets/ProfileCard'
import User_Not_Found from "../../Assets/SignUp/User_Not_Found.png";
import { useDispatch, useSelector } from 'react-redux';
import { getContactedUsers } from '../../Redux/Actions/UsersProfileAction';
import { toast } from 'react-toastify';
import { Skeleton } from '@mui/material';
import { CiSearch } from "react-icons/ci";
import AnimatedCounter from '../../utils/AnimatedCounter';
import Navbar from '../../Layaouts/Navbar';


const ContactedProfiles = () => {

  const dispatch = useDispatch();
  const UsersProfile = useSelector((state) => state.UsersProfile || {});
  const [profiledata, setProfileData] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const fetchContactedProfile = async () => {
      try {
        await dispatch(getContactedUsers(debouncedSearch));
      } catch (error) {
        toast.error(error?.response?.data?.message || "Contacted Data Not Found !!")
      }
    }

    fetchContactedProfile();
  }, [dispatch, debouncedSearch]);

  useEffect(() => {
    if (UsersProfile?.contactedUsers) {
      // console.log("API Response:", UsersProfile.contactedUsers);
      setProfileData(UsersProfile.contactedUsers.data);
    } else {
      toast.error('Contacted Data not found !!')
    }
  }, [UsersProfile]);

  return (
    <div className="container lg:w-[900px] xl:w-auto mx-auto px-4 py-6">
      <div className="w-full mx-auto bg-white">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
          <div className="text-lg md:text-xl font-semibold mb-2 md:mb-0">Profiles Contacted (<AnimatedCounter total={profiledata?.length} />)</div>
          <div className="relative">
            <div className="absolute inset-y-0 left-3 flex items-center text-gray-500"><CiSearch size={20} /></div>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
              className="w-full pl-10 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#E72848]"
            />
          </div>
        </div>
        <div className="grid w-full grid grid-cols-1 xl:grid-cols-2 custom-grid gap-3">
          {
            UsersProfile.loading || !profiledata ? (
              <>
                {Array.from({ length: 4 }).map((_, index) => (
                  <div key={index} className="col-span-1">
                    <Skeleton
                      sx={{ borderRadius: "10px" }}
                      variant="square"
                      width="100%"
                      height={200}
                    />
                  </div>
                ))}
              </>
            ) : (
              <>
                {
                  profiledata.length < 1 ? (
                    <div className="w-full col-span-2 flex justify-center items-center py-10 my-10 flex-col">
                      <img src={User_Not_Found} alt="" />
                      <h1 className="col-span-2 text-center font-bold text-2xl my-3">
                        Contacted Profile Not Found !!
                      </h1>
                    </div>
                  ) : (
                    profiledata.map((profile) => (
                      <React.Fragment key={profile?.id}>
                        <ProfileCard profile={profile} page="ContactedProfiles" />

                      </React.Fragment>
                    ))
                  )
                }
              </>

            )
          }
        </div>
      </div>
    </div>
  )
}

export default ContactedProfiles